module.exports = __webpack_public_path__ + "assets/images/electoral-college/diverging-votes/mobile.svg?v=f1a9aa16";